import React from 'react';

import { TODAY } from '../../constants';
import { useApp } from '../../store/AppContext';
import PeriodNavigation from './PeriodNavigation';
import TimelineViewControls from './TimelineViewControls';

/* Titre, navigation dans le temps (dont retour à aujourd'hui) et réglages d'affichage. */
export default function TimelineToolbar({ periodLabel }) {
  const { timelineBodyScrollRef, update } = useApp();
  return (
    <div className="page-header grid [grid-template-columns:1fr_auto_1fr]">
      <h1 className="page-title">Timeline</h1>
      <div className="flex items-center gap-[8px]">
        <PeriodNavigation periodLabel={periodLabel} />
        <button
          className="btn"
          onClick={() => {
            update((s) => ({ ...s, tlStart: new Date(TODAY) }));
            if (timelineBodyScrollRef.current) timelineBodyScrollRef.current.scrollLeft = 0;
          }}
        >
          Aujourd'hui
        </button>
      </div>
      <TimelineViewControls />
    </div>
  );
}
